import Vue from 'vue'
import Router from 'vue-router'

import index from '../components/index'
import products from '../components/product/products'
import center from '../components/center/center'
import bridge from '../components/center/bridge/bridge'
import modalTest from '../components/center/bridge/bridge-modal'
import cableTest from '../components/center/bridge/bridge-cable'
import earthquakeTest from '../components/center/bridge/bridge-earthquake'
import news from '../components/news/news'
import newsDetail from '../components/news/news-detail'
import download from '../components/download'
import downloadList from '../components/download-detail'
import about from '../components/about/about'
import aboutCompany from '../components/about/about-company'
import aboutCertificate from '../components/about/about-certificate'
import join from '../components/join/join'
import contact from '../components/contact'
import sensitivity from '../components/sensitivity'
import NotFoundComponent from '../components/NotFoundComponent'
import notice from '../components/notice'

// TODO:待优化
// 产品中心
// 振动传感器系列
import vibrate from '../components/product/vibrate/vibrate'
import productDetails from '../components/product/productDetails'
import BY_S07 from '../components/product/vibrate/BY_S07'
import B941B from '../components/product/vibrate/941B'
import B991B from '../components/product/vibrate/991B'
import BY_S07D from '../components/product/vibrate/BY_S07D'
import P12H from '../components/product/vibrate/P12H'
import BY_S02 from '../components/product/vibrate/BY_S02'
import B891_2 from '../components/product/vibrate/891_2'
import B891_4 from '../components/product/vibrate/891_4'
import IEPE from '../components/product/vibrate/IEPE'

// 数据采集仪系列
import Device from '../components/product/device/device'
import D1000 from '../components/product/device/D1000'
import D2000A from '../components/product/device/D2000A'
import D3000 from '../components/product/device/D3000'

// 其他传感器
import other from '../components/product/other/other'
import QYM from '../components/product/other/QYM'
import GV from '../components/product/other/GV'

// 振动台系列
import vibrostand from '../components/product/vibrostand/vibrostand'
import LVT from '../components/product/vibrostand/LVT'
import XL from '../components/product/vibrostand/XL-1'

// 核心业务
// 大坝振动监测
import dam from '../components/center/dam/dam'

// 大坝振动监测
import highRise from '../components/center/high-rise/high-rise'

// 大坝振动监测
import wind from '../components/center/wind/wind'

// 井下振动监测
import pit from '../components/center/pit/pit'
import laboratory from '../components/center/pit/laboratory'
import mine from '../components/center/pit/mine'
import tremor from '../components/center/pit/tremor'

// 特殊精密场所振动监测
import precision from '../components/center/precision/precision'

// 分布式在线监测系统
import cloud from '../components/product/cloud/cloud'

import wave from '../components/product/wave/wave'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'indexDefault',
      component: index
    },
    {
      path: '/home',
      name: 'home',
      component: index
    },
    // 产品中心
    {
      path: '/products',
      name: 'products',
      component: products,
      meta: {
        title: '产品中心',
        enTitle: 'product'
      }
    },
    // 核心业务
    {
      path: '/center',
      name: 'center',
      component: center,
      meta: {
        title: '核心业务',
        enTitle: 'center'
      }
    },
    {
      path: '/bridge',
      name: 'bridge',
      component: bridge,
      meta: {
        title: '桥梁检测',
        enTitle: 'bridge'
      }
    },
    {
      path: '/precision',
      name: 'precision',
      component: precision,
      meta: {
        title: '特殊精密场所振动监测',
        enTitle: 'precision'
      }
    },
    {
      path: '/modalTest',
      name: 'modalTest',
      component: modalTest,
      meta: {
        title: '模态测试',
        enTitle: 'bridge'
      }
    },
    {
      path: '/cableTest',
      name: 'cableTest',
      component: cableTest,
      meta: {
        title: '索力测试',
        enTitle: 'bridge'
      }
    },
    {
      path: '/earthquakeTest',
      name: 'earthquakeTest',
      component: earthquakeTest,
      meta: {
        title: '地震或船撞监测',
        enTitle: 'bridge'
      }
    },
    // 新闻中心
    {
      path: '/news',
      name: 'news',
      component: news,
      meta: {
        title: '新闻中心',
        enTitle: 'local'
      }
    }, {
      path: '/newsDetail',
      name: 'newsDetail',
      component: newsDetail,
      meta: {
        title: '公司新闻',
        enTitle: 'newsDetail'
      }
    }, {
      path: '/download',
      name: 'download',
      component: download,
      meta: {
        title: '下载中心',
        enTitle: 'media'
      }
    }, {
      path: '/downloadList',
      name: 'downloadList',
      component: downloadList,
      meta: {
        title: '下载列表',
        enTitle: 'media'
      }
    }, {
      path: '/about',
      name: 'about',
      component: about,
      meta: {
        title: '关于博远',
        enTitle: 'about'
      }
    }, {
      path: '/aboutCompany',
      name: 'aboutCompany',
      component: aboutCompany,
      meta: {
        title: '关于博远',
        enTitle: 'about'
      }
    }, {
      path: '/aboutCertificate',
      name: 'aboutCertificate',
      component: aboutCertificate,
      meta: {
        title: '资质证书',
        enTitle: 'about'
      }
    }, {
      path: '/join',
      name: 'join',
      component: join,
      meta: {
        title: '加入我们',
        enTitle: ''
      }
    }, {
      path: '/contact',
      name: 'contact',
      component: contact,
      meta: {
        title: '联系我们',
        enTitle: ''
      }
    }, {
      path: '/sensitivity',
      name: 'sensitivity',
      component: sensitivity,
      meta: {
        title: '灵敏度查询',
        enTitle: ''
      }
    }, {
      path: '/notice',
      name: 'notice',
      component: notice,
      meta: {
        title: '公告',
        enTitle: ''
      }
    }, {
      path: '/vibrate',
      name: 'vibrate',
      component: vibrate,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/productDetails',
      name: 'productDetails',
      component: productDetails,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/BY_S07',
      name: 'BY_S07',
      component: BY_S07,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/B941B',
      name: 'B941B',
      component: B941B,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/B991B',
      name: 'B991B',
      component: B991B,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/BY_S07D',
      name: 'BY_S07D',
      component: BY_S07D,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/P12H',
      name: 'P12H',
      component: P12H,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/BY_S02',
      name: 'BY_S02',
      component: BY_S02,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/B891_2',
      name: 'B891_2',
      component: B891_2,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/B891_4',
      name: 'B891_4',
      component: B891_4,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/IEPE',
      name: 'IEPE',
      component: IEPE,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/Device',
      name: 'Device',
      component: Device,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/D1000',
      name: 'D1000',
      component: D1000,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/D2000A',
      name: 'D2000A',
      component: D2000A,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/D3000',
      name: 'D3000',
      component: D3000,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/other',
      name: 'other',
      component: other,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/QYM',
      name: 'QYM',
      component: QYM,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/GV',
      name: 'GV',
      component: GV,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/vibrostand',
      name: 'vibrostand',
      component: vibrostand,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/LVT',
      name: 'LVT',
      component: LVT,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/XL',
      name: 'XL',
      component: XL,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/dam',
      name: 'dam',
      component: dam,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/highRise',
      name: 'highRise',
      component: highRise,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    },
    {
      path: '/pit',
      name: 'pit',
      component: pit,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/wind',
      name: 'wind',
      component: wind,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    },
    {
      path: '/laboratory',
      name: 'laboratory',
      component: laboratory,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    },
    {
      path: '/tremor',
      name: 'tremor',
      component: tremor,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/cloud',
      name: 'cloud',
      component: cloud,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    }, {
      path: '/wave',
      name: 'wave',
      component: wave,
      meta: {
        title: '振动传感器系列',
        enTitle: ''
      }
    },
    {
      path: '*',
      component: NotFoundComponent,
      meta: {
        title: '浙江博远电子科技有限公司',
        enTitle: '浙江博远电子科技有限公司'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js